import React, {useEffect, useState} from 'react'
import Tools from '../../cvp-webgames-core/Misc/Tools';
import {constants} from '../../misc/constants';
import {generalAudioCaching, getGlobalTextSizeStyle, getSaveData, PageType, parseDynamicHtml, setFocus, TextHtmlTagType} from '../../misc/tools';
import {BaseConfig} from '../BaseConfig';
import Button2 from '../general/button2';
import PopUp2 from '../general/pop-up2';
import {UIProperties} from '../../cvp-webgames-core/Components/ui/UIProperties';
import "./question-type1-ui.css"
import ReliabilityGaugeUI, {ReliabilityGaugeType} from './reliability-gauge-ui';
import ReplayContentUI from './replay-content-ui';
import {
    coreGeneralQuestionUIBaseImplementation,
    GeneralQuestionUIConfig,
    GeneralQuestionUIConfigOption
} from '../../cvp-webgames-core/Components/ui/react/core-general-question-ui';

const QuestionType1UI = (props: UIProperties<QuestionType1UIConfig>) => {
	const baseImplementation = coreGeneralQuestionUIBaseImplementation.getImplementation(props.parameters);
    const selectedOptionIndex: number = baseImplementation.getSelectedOptions() as number;
    const [forcedUpdate, setForcedUpdate] = useState(0);
    const singleOptionWidth = props.parameters.options.length === 6 ? 210 : 270;


	useEffect(() => {
		if(forcedUpdate === 0) {
            const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.music_marimba_chord_01).src;
			Tools.playOneShotSound(url);

            baseImplementation.init(() => {
                setForcedUpdate(forcedUpdate + 1);
            })
        }
	}, []);

    const renderDescription = () => {
        return (
            <div className='question-type1-ui-sub-container-desc-container'>
                <div style={{
                    left: (() => {
                        var initial = props.parameters.options.length === 4 ? 276 : 104;
                        var val = initial + (singleOptionWidth) * selectedOptionIndex;
                        return val + 'px'
                    })()
                }} className='question-type1-ui-arrow-container'>
                    <i className='question-type1-ui-arrow'></i>
                </div>
                <div
                    className='center-element-horizontal main-content-inner question-type1-ui-sub-container-desc-container-inner'>
                    <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='default-text center-element-horizontal' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.options[selectedOptionIndex].description) }}></p>
                </div>
            </div>
        );
    }

	const onQuestionSubmitted = () => {
        baseImplementation.onQuestionSubmitted()
		props.parameters.onSubmitClicked(props.parameters.options, [props.parameters.options[selectedOptionIndex]], props.parameters);
	}

    setTimeout(() => {
        const options = document.querySelectorAll('.question-type1-ui-sub-container-question-single-option');
        const parent = options[0].parentElement;
        for(var indx = 0; indx < options.length; indx++) {
            options[indx].setAttribute('style', `width: ${singleOptionWidth}px;`)
        }
    }, 0);

    return (
        <div className="modal-disable-select question-type1-ui-container" style={{}}>
            <div className='gauges'>
                <div className='question-type1-ui-reliab-gauge'>
                    <ReliabilityGaugeUI percentage={props.parameters.percentage}
                                        type={ReliabilityGaugeType.Type1}></ReliabilityGaugeUI>
                </div>
            </div>
            <div aria-label='Question' className={`question-type1-ui-inner-container center-element ${constants.mainContent508Id}`}>
                <PopUp2
                    titleLeft={constants.projectTitle}
                    titleRight={props.parameters.title}
                    subtitleRight={props.parameters.subtitle}
                    onRenderContent={() => {
                        return (
                            <div>
                                <div className='question-type1-ui-sub-container main-content-inner center-element-horizontal'>
                                    <div
                                        className='center-element-horizontal question-type1-ui-sub-container-question-title'>
                                        <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='center-element default-text'>{props.parameters.questionTitle}</p>
                                    </div>
                                    <div className="question-type1-ui-sub-container-question-options" style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}>
                                        {props.parameters.options.map((option: GeneralQuestionUIConfigOption, index: number) => {
                                            return (
                                                <div className='question-type1-ui-sub-container-question-single-option' style={{
                                                    width: `${singleOptionWidth}px`
                                                }} key={Tools.generateGuid()}>
                                                    <Button2 width='100%'
                                                            idFor508={'question-type-1-content-top'}
                                                             height='100%'
                                                             backgroundColor='rgb(55, 70, 104)'
                                                             hoverBgColor={constants.design.hoverColor1}
                                                             onClick={() => {
                                                                 baseImplementation.onOptionSelected(option, index, () => {
                                                                    setForcedUpdate(forcedUpdate + 1);
                                                                    setFocus('question-option-submit');
                                                                 })
                                                             }}
                                                             onRenderContent={() => {
                                                                 return (
                                                                    <div style={{
                                                                        position: 'relative',
                                                                        // height: '160px',
                                                                        height: '100%',
                                                                        minHeight: '100px',
                                                                        overflow: 'hidden',
                                                                        display: 'flex'
                                                                    }}>
                                                                        <div style={{
                                                                            width: '100%'
                                                                        }}>
                                                                            <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p),
                                                                                position: 'relative',
                                                                                top: '50%',
                                                                                transform: 'translateY(-50%)'
                                                                            }} className='default-text option-text'>{option.title}</p>
                                                                        </div>
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            width: '30px',
                                                                            height: '30px',
                                                                            top: '9px',
                                                                            left: '10px',
                                                                            backgroundColor: selectedOptionIndex !== index ? '#D3E1EA' : 'rgb(55, 70, 104)',
									                                        borderRadius: '5px'
                                                                        }}></div>
                                                                    </div>
                                                                 )
                                                             }}
                                                             isSelected={baseImplementation.isOptionSelected(index)}
                                                             ariaLabel={option.title + (selectedOptionIndex === index ? ' (selected)' : ' (unselected)')}></Button2>
                                                </div>

                                            )
                                        })}
                                    </div>
                                    {selectedOptionIndex !== -1 ? renderDescription() : null}
                                </div>
                                <div
                                    className='center-element-horizontal question-type1-ui-sub-container-question-submit'>
                                    <Button2 width='100%'
                                             height='100%'
                                             idFor508='question-option-submit'
                                             onClick={() => {
                                                 onQuestionSubmitted()
                                             }}
                                             onRenderContent={() => {
                                                 return (
                                                     <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text center-element'>Submit</p>
                                                 )
                                             }}
                                             isSelected={false}
                                             isDisabled={selectedOptionIndex === -1}
                                             updateDisableOpacity={true}
                                            hoverBgColor={constants.design.hoverColor2}
                                            ariaLabel={'Submit'}></Button2>
                                </div>
                            </div>
                        );
                    }}></PopUp2>
            </div>

            <div className='question-type1-ui-replay-bttn'>
                <ReplayContentUI onReplayContentClicked={props.parameters.onReplayContentClicked}></ReplayContentUI>
            </div>
        </div>
    );

};

export interface QuestionType1UIConfig extends GeneralQuestionUIConfig {
    title: PageType;
    percentage?: number;
    subtitle: string;
    onReplayContentClicked?: () => void;
}

export default QuestionType1UI;